export const localStorageKey = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
};
